import { Typography, Box, Skeleton } from '@mui/material';
import { useCustomerAcknowledgmentStatement } from '../../hooks';

export const AcknowledgmentStatement = () => {
  const { statement, isLoading } = useCustomerAcknowledgmentStatement();

  if (isLoading) {
    return (
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="80%" height={24} />
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="body1"
        sx={{
          color: 'text.primary',
          fontWeight: 500,
          lineHeight: 1.6
        }}
      >
        {statement}
      </Typography>
    </Box>
  );
};
